// extracted by mini-css-extract-plugin
export var back = "back-to-module--back--9e739";
export var spin = "back-to-module--spin--cbd9e";